/*
  si-paket.js · Raumauswahl für die Paket-Produktseiten (Vorlage product.paket)
  Fassung 1 vom 05.10.2026. Fassung 2 vom 06.10.2026: mehrere Karten pro Seite (Paketkarten, data-si-paket-karte).
  Fassung 3 vom 08.10.2026: Paket 2 „Neue Produkte“ je Raum statt für alle Räume (schmale Auswahl in der Raumzeile).
  Fassung 4 vom 08.10.2026: statt zwei Knöpfen ein Schalter „Mehr als 7 Neuprodukte“, wie die Shoppingliste in Paket 3.
  Fassung 5 vom 08.10.2026: „?“ an der Shoppingliste (HILFE_LISTE bzw. Metafeld custom.hilfe_shoppingliste).
  Fassung 6 vom 08.10.2026: „?“ in jeder Raumzeile; Hilfefenster schließen per Klick/Tipp daneben oder Escape.
  Fassung 7 vom 23.10.2026: wie Find Your Service. Küche, Bad, Esszimmer mit Küche und Wohn- & Essküche sind
    wählbar, aber nicht buchbar: Die Zeile zeigt statt Preis den Hinweis „Lass uns kurz sprechen“ mit Link zum FYS.
    Bis zu 3 Räume (max aus den Daten), ab 4 individuelles Angebot.
  Fassung 9 vom 31.10.2026: Im Warenkorb (snippet si-korb-weitere) dieselbe Auswahl für „Weiteres Paket hinzufügen“.
    Das Ereignis si_paket_add_to_cart trägt dann quelle: 'warenkorb'. Nach dem Hinzufügen lädt /cart neu.

  Liest Varianten und Optionen aus dem Produkt (JSON in #si-paket-daten) und erkennt das Paket an den Optionen:
    nur „Raum“                      → Paket 1 Beratungsstunde
    „Raum“ + „Neue Produkte“        → Paket 2 Styling Upgrade (Option je Raum)
    „Raum“ + „Shoppingliste“        → Paket 3 Design Concept (Liste je Raum)
  Werte der Option „Raum“: Einzelraum · Kombinierter Raum - 2 Bereiche.

  Jeder Raum wird eine eigene Warenkorb-Zeile mit der Eigenschaft „Dein Raum“.
  Kommt die Kundin aus Find Your Service, übernimmt die Seite die Auswahl aus der URL:
    ?raeume=schlafzimmer,wohnkueche&liste=wohnkueche&option=…&mehr7=schlafzimmer&fys=…
  und hängt die Kennung als versteckte Eigenschaft _fys_id an jede Zeile.
*/
(function () {
  'use strict';

  // Fassung 8 (23.10.2026): Räume, Namen und Reihenfolge wie im Find Your Service (si-fys2.js RAEUME), der FYS ist führend.
  // Nicht buchbar (wie im FYS individuelles Angebot): Küche, Bad, Anderer Raum, Esszimmer mit Küche, Wohn- & Essküche,
  // Andere Kombination. Sie bleiben wählbar und zeigen statt Preis „Lass uns kurz sprechen“.
  var RAEUME = [
    ['Einzelne Räume', [
      ['wohnzimmer', 'Wohnzimmer', 'einzel'], ['esszimmer', 'Esszimmer', 'einzel'], ['schlafzimmer', 'Schlafzimmer', 'einzel'],
      ['flur', 'Flur', 'einzel'], ['homeoffice', 'Arbeitszimmer', 'einzel'], ['kinderzimmer', 'Kinderzimmer', 'einzel'],
      ['kueche', 'Küche', 'sprechen'], ['bad', 'Bad', 'sprechen'], ['anderes', 'Anderer Raum', 'sprechen']]],
    ['Kombinierte Räume', [
      ['wohness', 'Wohn- & Esszimmer', 'offen2'], ['kuecheess', 'Esszimmer mit Küche', 'sprechen'],
      ['wohnkueche', 'Wohn- & Essküche', 'sprechen'], ['kombi', 'Andere Kombination', 'sprechen']]]
  ];
  var RAUM = {};
  RAEUME.forEach(function (g) { g[1].forEach(function (r) { RAUM[r[0]] = { id: r[0], name: r[1], stufe: r[2] }; }); });
  function sprechen(id) { return RAUM[id].stufe === 'sprechen'; }

  // Welcher Wert der Option „Raum“ gilt je Preisstufe und Paket (erster vorhandener gewinnt)
  var RAUM_WERT = {
    // Variante seit 23.10.2026 „Kombinierter Raum - 2 Bereiche“ (vorher „Offener Raum - 2 Bereiche“)
    beratung: { einzel: ['Einzelraum'], offen2: ['Kombinierter Raum - 2 Bereiche'] },
    styling: { einzel: ['Einzelraum'], offen2: ['Kombinierter Raum - 2 Bereiche'] },
    concept: { einzel: ['Einzelraum'], offen2: ['Kombinierter Raum - 2 Bereiche'] }
  };
  var STUNDEN = { einzel: 'ca. 1 Std.', offen2: 'ca. 1,5 Std.' };
  var LISTE_TEXT = { einzel: 'Shoppingliste', offen2: 'Shoppingliste' };
  var SPRECHEN_KUECHE = 'Küche und Bad planen wir individuell, weil Küchenstudio oder Sanitärbetrieb mitplanen. Erzähl uns kurz davon, dann bekommst Du ein passendes Angebot.';
  var SPRECHEN_TEXT = {
    kueche: SPRECHEN_KUECHE, bad: SPRECHEN_KUECHE, kuecheess: SPRECHEN_KUECHE, wohnkueche: SPRECHEN_KUECHE,
    anderes: 'Diesen Raum schauen wir uns gern erst gemeinsam an. Erzähl uns kurz davon, dann bekommst Du ein passendes Angebot.',
    kombi: 'Andere Kombinationen planen wir individuell, weil jeder Raum anders zusammenspielt. Erzähl uns kurz davon, dann bekommst Du ein passendes Angebot.'
  };

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function start(root, nr) {
    // Eindeutige IDs, wenn mehrere Karten auf einer Seite stehen (Paketkarten)
    var pre = root.dataset.siPaketId || ('si' + nr);
    var daten = JSON.parse(root.querySelector('[data-si-paket-daten]').textContent);
    var optionen = daten.optionen, varianten = daten.varianten, max = daten.max || 3, geldFormat = daten.geldFormat || '€{{amount_with_comma_separator}}';
    var fysLink = daten.fysLink || '/pages/find-your-service?von=kueche_bad';
    var iRaum = optionen.indexOf('Raum'), iListe = optionen.indexOf('Shoppingliste'), iProdukte = optionen.indexOf('Neue Produkte');
    var paket = iListe >= 0 ? 'concept' : iProdukte >= 0 ? 'styling' : 'beratung';
    var i2 = iListe >= 0 ? iListe : iProdukte;
    // Werte der zweiten Option in der Reihenfolge aus Shopify
    var werte2 = [];
    if (i2 >= 0) varianten.forEach(function (v) { if (werte2.indexOf(v.options[i2]) < 0) werte2.push(v.options[i2]); });
    var MIT = werte2.filter(function (w) { return /^(mit|inkl)/i.test(w); })[0];
    var W_MEHR = werte2.filter(function (w) { return /mehr/i.test(w); })[0] || werte2[1];
    var OHNE = werte2.filter(function (w) { return /^ohne/i.test(w); })[0];

    // Text im „?“ bei Paket 2: Metafeld custom.hilfe_neuprodukte am Produkt Styling Upgrade (Shopify-Admin).
    // Leerzeile = neuer Absatz, **so** = fett. Ohne Metafeld gilt der Standardtext.
    var HILFE_STANDARD = '**Bis 7** reicht, wenn die Basics stehen und nur das gewisse Etwas fehlt.\n\n**Mehr als 7** passt, wenn auch mehrere Möbel und Accessoires dazukommen sollen.\n\nUnsicher? Starte mit bis 7, wir erweitern flexibel.';
    // Text im „?“ an der Shoppingliste (Paket 3), gleiches Format: Leerzeile = Absatz, **so** = fett
    var HILFE_LISTE = 'Eine Liste aller Möbel und Accessoires aus Deinem Design, mit direkten Links zum Bestellen.\n\n**Unsicher?** Buch Dein Design erstmal ohne Shoppingliste. Du kannst sie nachträglich dazubuchen.';
    function absaetze(text) {
      return String(text).split(/\n\s*\n/).map(function (abs) {
        return '<p>' + esc(abs.trim()).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>') + '</p>';
      }).join('');
    }
    var listeHtml = absaetze(daten.hilfeListe || HILFE_LISTE);
    var hilfeHtml = String(daten.hilfeNeu || HILFE_STANDARD).split(/\n\s*\n/).map(function (abs) {
      return '<p>' + esc(abs.trim()).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>') + '</p>';
    }).join('');

    var el = {
      zeilen: root.querySelector('[data-zeilen]'), plus: root.querySelector('[data-plus]'), mehr: root.querySelector('[data-mehr]'),
      option: root.querySelector('[data-option]'), summe: root.querySelector('[data-summe]'), anzahl: root.querySelector('[data-anzahl]'),
      knopf: root.querySelector('[data-buchen]'), fehler: root.querySelector('[data-fehler]'), fys: root.querySelector('[data-fys]')
    };

    function geld(cent) {
      cent = Math.round(cent);
      var ganz = Math.floor(cent / 100), rest = cent % 100;
      var punkte = String(ganz).replace(/\B(?=(\d{3})+(?!\d))/g, '.'), kommas = String(ganz).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var nk = ('0' + rest).slice(-2);
      return geldFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, art) {
        if (art === 'amount_no_decimals') return kommas;
        if (art === 'amount_no_decimals_with_comma_separator') return punkte;
        if (art === 'amount_with_comma_separator') return punkte + ',' + nk;
        return kommas + '.' + nk;
      });
    }

    function variante(stufe, wert2) {
      var kandidaten = RAUM_WERT[paket][stufe] || [];
      for (var k = 0; k < kandidaten.length; k++) {
        for (var j = 0; j < varianten.length; j++) {
          var v = varianten[j];
          if (v.options[iRaum] === kandidaten[k] && (i2 < 0 || wert2 === undefined || v.options[i2] === wert2)) return v;
        }
      }
      return null;
    }
    function erlaubt(id) { return sprechen(id) || !!variante(RAUM[id].stufe, i2 >= 0 ? (paket === 'concept' ? OHNE : werte2[0]) : undefined); }
    function buchbar() { return st.raeume.filter(function (r) { return !sprechen(r.id) && raumVariante(r); }); }

    // Zustand: je Raum eigene Liste (Paket 3) bzw. eigene Menge neuer Produkte (Paket 2)
    var st = { raeume: [{ id: erlaubt('wohnzimmer') ? 'wohnzimmer' : 'schlafzimmer', liste: false, neu: werte2[0] }], fys: '' };

    function raumVariante(r) {
      var s = RAUM[r.id].stufe;
      if (s === 'sprechen') return null;
      if (paket === 'concept') return variante(s, r.liste && variante(s, MIT) ? MIT : OHNE);
      if (paket === 'styling') return variante(s, r.neu || werte2[0]);
      return variante(s);
    }

    function zeichnen() {
      el.zeilen.innerHTML = st.raeume.map(function (r, i) {
        var s = RAUM[r.id].stufe, v = raumVariante(r);
        var auswahl = RAEUME.map(function (g) {
          return '<optgroup label="' + g[0] + '">' + g[1].map(function (o) {
            var ok = erlaubt(o[0]);
            var zusatz = !ok ? ' (nicht in diesem Paket)' : sprechen(o[0]) ? ' · individuelles Angebot' : '';
            return '<option value="' + o[0] + '"' + (o[0] === r.id ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(o[1] + zusatz) + '</option>';
          }).join('') + '</optgroup>';
        }).join('');
        var unten = '';
        if (s === 'sprechen') {
          unten = '<p class="si-paket__sprechen">' + SPRECHEN_TEXT[r.id] + ' <a href="' + esc(fysLink) + '">Lass uns kurz sprechen&nbsp;→</a></p>';
        } else if (paket === 'concept') {
          var mit = variante(s, MIT), ohne = variante(s, OHNE);
          var listeHilfe = '<details class="si-paket__info"><summary aria-label="Was ist die Shoppingliste?">?</summary><div class="si-paket__info-panel"><b>Was ist die Shoppingliste?</b>' + listeHtml + '</div></details>';
          unten = mit && ohne
            ? '<div class="si-paket__neu-zeile"><label class="si-paket__liste"><input type="checkbox" role="switch" data-liste="' + i + '" id="' + pre + '-liste-' + i + '"' + (r.liste ? ' checked' : '') + '><span>' + LISTE_TEXT[s] + '</span></label>' +
              '<small class="si-paket__neu-preis">+' + geld(mit.price - ohne.price) + '</small>' + listeHilfe + '</div>'
            : '';
        } else if (paket === 'beratung') {
          unten = '<p class="si-paket__hinweis">' + STUNDEN[s] + ' · abgerechnet nach Aufwand</p>';
        } else if (paket === 'styling') {
          // Schalter wie die Shoppingliste in Paket 3: aus = bis 7, an = mehr als 7 Neuprodukte (Fassung 4, 08.10.2026), „?“ in jeder Raumzeile
          var vBis = variante(s, werte2[0]), vMehr = variante(s, W_MEHR), an = r.neu === W_MEHR;
          var hilfe = '<details class="si-paket__info"><summary aria-label="Wann brauche ich mehr als 7 Neuprodukte?">?</summary><div class="si-paket__info-panel">' +
            '<b>Wie viele Neuprodukte brauchst Du?</b>' + hilfeHtml + '</div></details>';
          unten = (vMehr && vBis
            ? '<div class="si-paket__neu-zeile"><label class="si-paket__liste"><input type="checkbox" role="switch" data-neu="' + i + '" id="' + pre + '-neu-' + i + '"' + (an ? ' checked' : '') + '><span>Mehr als 7 Neuprodukte</span></label>' +
              '<small class="si-paket__neu-preis">+' + geld(vMehr.price - vBis.price) + '</small>' + hilfe + '</div>'
            : '');
        }
        return '<div class="si-paket__raum"><div class="si-paket__zeile">' +
          '<label class="si-paket__sr" for="' + pre + '-raum-' + i + '">Raum ' + (i + 1) + '</label>' +
          '<select id="' + pre + '-raum-' + i + '" data-raum="' + i + '">' + auswahl + '</select>' +
          '<span class="si-paket__preis">' + (v ? geld(v.price) : s === 'sprechen' ? '' : '–') + '</span>' +
          '<button type="button" class="si-paket__weg" data-weg="' + i + '" aria-label="Raum ' + (i + 1) + ' entfernen"' + (st.raeume.length < 2 ? ' disabled' : '') + '>×</button></div>' +
          unten + '</div>';
      }).join('');
      // Summe und Anzahl nur für buchbare Räume. Ist kein Raum buchbar (nur Küche/Bad), führt der Knopf zum Gespräch.
      var gebucht = buchbar();
      var summe = gebucht.reduce(function (n, r) { return n + raumVariante(r).price; }, 0);
      el.summe.textContent = geld(summe);
      el.anzahl.textContent = gebucht.length + (gebucht.length === 1 ? ' Raum' : ' Räume');
      var nurSprechen = !gebucht.length;
      if (!el.knopfText) { var sp = el.knopf.querySelector('span'); el.knopfText = sp; el.knopfStandard = sp ? sp.textContent : ''; }
      if (el.knopfText) el.knopfText.textContent = nurSprechen ? 'Lass uns sprechen' : el.knopfStandard;
      el.knopf.classList.toggle('si-paket__buchen--sprechen', nurSprechen);
      var summeZeile = el.summe.parentNode;
      if (summeZeile) summeZeile.style.display = nurSprechen ? 'none' : ''; // kein „Gesamt 0 €“ (hidden greift wegen display:flex nicht)
      el.plus.disabled = st.raeume.length >= max;
      el.mehr.hidden = st.raeume.length < max;
      el.fehler.hidden = true;
      // Paketkarten: Hat irgendeine Karte mehr als einen Raum, behält jede Karte ihre eigene Höhe
      // (sonst entsteht in den anderen Karten eine Lücke über dem Buchungsbereich).
      var grid = root.closest('.design-paket-cards-grid');
      if (grid) grid.classList.toggle('si-mehrere-raeume', [].some.call(grid.querySelectorAll('[data-si-paket]'), function (k) { return k.querySelectorAll('.si-paket__raum').length > 1; }));
    }

    el.zeilen.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-raum]')) { st.raeume[+t.dataset.raum].id = t.value; zeichnen(); fokus(pre + '-raum-' + t.dataset.raum); }
      if (t.matches('[data-liste]')) { st.raeume[+t.dataset.liste].liste = t.checked; zeichnen(); fokus(pre + '-liste-' + t.dataset.liste); }
      if (t.matches('[data-neu]')) { st.raeume[+t.dataset.neu].neu = t.checked ? W_MEHR : werte2[0]; zeichnen(); fokus(pre + '-neu-' + t.dataset.neu); }
    });
    el.zeilen.addEventListener('click', function (e) {
      var b = e.target.closest('[data-weg]');
      if (b && !b.disabled) { st.raeume.splice(+b.dataset.weg, 1); zeichnen(); el.plus.focus(); }
    });
    el.plus.addEventListener('click', function () {
      if (st.raeume.length >= max) return;
      var letzter = st.raeume[st.raeume.length - 1];
      st.raeume.push({ id: erlaubt('schlafzimmer') ? 'schlafzimmer' : 'wohnzimmer', liste: letzter.liste, neu: letzter.neu });
      zeichnen();
      fokus(pre + '-raum-' + (st.raeume.length - 1));
    });
    function fokus(id) { var n = document.getElementById(id); if (n) n.focus(); }

    // Vorauswahl aus Find Your Service
    if (!root.hasAttribute('data-si-paket-karte')) (function () {
      var q = new URLSearchParams(location.search);
      var ids = (q.get('raeume') || '').split(',').filter(function (id) { return RAUM[id] && erlaubt(id); }).slice(0, max);
      var liste = (q.get('liste') || '').split(',');
      if (ids.length) {
        st.raeume = ids.map(function (id) { return { id: id, liste: liste.indexOf(id) >= 0 || q.get('option') === 'mit', neu: werte2[0] }; });
        if (el.fys) el.fys.hidden = false;
      }
      if (paket === 'styling' && q.get('option')) {
        var w = q.get('option') === 'mehr7' ? werte2[1] : q.get('option') === 'bis7' ? werte2[0] : null;
        if (w) st.raeume.forEach(function (r) { r.neu = w; });
      }
      // Seit 08.10.2026 schickt Find Your Service die Räume mit „mehr als 7“ einzeln mit (&mehr7=…)
      if (paket === 'styling' && q.get('mehr7') !== null) {
        var mehr = q.get('mehr7').split(',');
        st.raeume.forEach(function (r) { r.neu = mehr.indexOf(r.id) >= 0 ? W_MEHR : werte2[0]; });
      }
      st.fys = (q.get('fys') || '').replace(/[^a-z0-9-]/gi, '').slice(0, 40);
    })();

    // Jetzt buchen: eine Zeile je Raum, danach zum Warenkorb
    el.knopf.addEventListener('click', function () {
      if (!buchbar().length) {
        if (window.dataLayer) window.dataLayer.push({ event: 'si_paket_sprechen', paket: paket });
        location.href = fysLink;
        return;
      }
      // Küche/Bad-Zeilen haben keine Variante und fallen hier heraus (filter Boolean)
      var items = st.raeume.map(function (r) {
        var v = raumVariante(r), props = { 'Dein Raum': RAUM[r.id].name };
        if (st.fys) props._fys_id = st.fys;
        return v ? { id: v.id, quantity: 1, properties: props } : null;
      }).filter(Boolean);
      if (!items.length) return;
      el.knopf.disabled = true;
      el.knopf.classList.add('is-loading');
      var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(basis + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
        .then(function () {
          // Fassung 9 (31.10.2026): quelle = data-si-paket-quelle (z. B. „warenkorb“ für „Weiteres Paket hinzufügen“), sonst „seite“
          if (window.dataLayer) window.dataLayer.push({ event: 'si_paket_add_to_cart', paket: paket, raeume: st.raeume.length, quelle: root.dataset.siPaketQuelle || 'seite' });
          location.href = basis + 'cart';
        })
        .catch(function (err) {
          el.fehler.hidden = false;
          el.fehler.textContent = 'Das hat nicht geklappt: ' + err.message + ' Bitte versuch es noch einmal oder schreib uns.';
          el.knopf.disabled = false;
          el.knopf.classList.remove('is-loading');
        });
    });

    zeichnen();
  }

  // Styles der Auswahl „Neue Produkte“ je Raum (Paket 2). Hier statt im Theme-CSS, damit sie auch auf
  // Seiten greifen, die eigenes CSS mitbringen (PageFly-Paketseite bis zum Umzug).
  function stil() {
    if (document.getElementById('si-paket-neu-css')) return;
    var s = document.createElement('style');
    s.id = 'si-paket-neu-css';
    s.textContent = '.si-paket__neu-zeile { display: flex; align-items: center; gap: 8px; }'
      + ' .si-paket__neu-zeile .si-paket__liste { flex: 0 1 auto; }'
      + ' .si-paket__neu-preis { margin-left: auto; font-size: var(--font-size-sm, 14px); font-weight: 600; color: var(--color-text-secondary, #5a6666); font-variant-numeric: tabular-nums; white-space: nowrap; }'
      + ' .si-paket__neu-zeile .si-paket__info summary { width: 20px; height: 20px; font-size: 12px; }'
      // Fassung 7: Hinweis bei Küche/Bad statt Preis (helles Lime wie die Fakten-Pillen im FYS)
      + ' .si-paket__sprechen { margin: 0; padding: 10px 12px; border-radius: 8px; background: var(--color-bg-accent, #f7fce8); font-size: var(--font-size-sm, 14px); line-height: 1.5; color: var(--color-primary); }'
      + ' .si-paket__sprechen a { display: inline-block; margin-top: 4px; font-weight: 700; color: var(--color-primary); text-decoration: underline; text-decoration-color: var(--color-secondary); text-decoration-thickness: 2px; text-underline-offset: 4px; }'
      + ' .si-paket__sprechen a:hover { color: var(--color-secondary); }';
    document.head.appendChild(s);
  }

  // „?“-Fenster (details.si-paket__info): schließen bei Klick oder Tipp irgendwo anders, auch auf das
  // Fenster selbst, und mit Escape. Ein Klick auf ein anderes „?“ schließt das bisherige.
  function hilfeSchliessen(ausser) {
    document.querySelectorAll('details.si-paket__info[open]').forEach(function (d) { if (d !== ausser) d.open = false; });
  }
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('details.si-paket__info > summary');
    hilfeSchliessen(sum ? sum.parentNode : null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hilfeSchliessen(null); });

  function alle() { stil(); document.querySelectorAll('[data-si-paket]').forEach(function (root, nr) { if (!root.dataset.siPaketBereit) { root.dataset.siPaketBereit = '1'; start(root, nr); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();